import { render, staticRenderFns } from "./longTimeNoUseAlarm.vue?vue&type=template&id=7622ab47&scoped=true"
import script from "./longTimeNoUseAlarm.vue?vue&type=script&lang=js"
export * from "./longTimeNoUseAlarm.vue?vue&type=script&lang=js"
import style0 from "./longTimeNoUseAlarm.vue?vue&type=style&index=0&id=7622ab47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622ab47",
  null
  
)

export default component.exports